export default function CardContainer({ cardInformation }) {
  return (
    <div className="card-container d-flex justify-content-center flex-wrap">
      {cardInformation.map((value) => {
        return <CardItem value={value}></CardItem>;
      })}
    </div>
  );
}
export function CardItem({ value }) {
  return (
    <div className="card-item" style={{ backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 75%, black 150%), ${value.background}` }}>
      <div className="card-icon">{value.icon}</div>
      <div className="title">{value.title}</div>
      <div className="number fw-bold ">{value.number}</div>
      <div className="date ">{value.date}</div>
    </div>
  );
}
